export var bookapiTransferOffersActionTypes;
(function (bookapiTransferOffersActionTypes) {
    bookapiTransferOffersActionTypes["INITIAL_BOOKAPI_TRANSFER_OFFERS_STATE"] = "INITIAL_BOOKAPI_TRANSFER_OFFERS_STATE";
    bookapiTransferOffersActionTypes["RECEIVE_BOOKAPI_TRANSFER_OFFERS_STATE"] = "RECEIVE_BOOKAPI_TRANSFER_OFFERS_STATE";
    bookapiTransferOffersActionTypes["RECEIVE_BOOKAPI_TRANSFER_OFFERS_FAILED"] = "RECEIVE_BOOKAPI_TRANSFER_OFFERS_FAILED";
})(bookapiTransferOffersActionTypes || (bookapiTransferOffersActionTypes = {}));
export var initialBookapiTransferOffersStateAction = {
    type: bookapiTransferOffersActionTypes.INITIAL_BOOKAPI_TRANSFER_OFFERS_STATE
};
